import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { timeout } from 'rxjs/operators';
import { PatientService } from 'generated-api';
import { SessionService } from '../services/session.service';

export const patientAccessGuard: CanActivateFn = async (route) => {
  const sessionService = inject(SessionService);
  const patientService = inject(PatientService);
  const router = inject(Router);

  if (!sessionService.isSessionLoaded()) {
    try {
      await firstValueFrom(
        sessionService.checkSessionStatus().pipe(timeout(5000))
      );
    } catch {
      router.navigate(['/']);
      return false;
    }
  }

  if (!sessionService.isAuthenticated()) {
    router.navigate(['/']);
    return false;
  }

  const patientId = route.paramMap.get('clientId');
  const evaluationTypeId = route.paramMap.get('evaluationTypeId') ?? undefined;

  if (!patientId) {
    router.navigate(['/unauthorized']);
    return false;
  }

  try {
    await firstValueFrom(patientService.verifyAccess(patientId, evaluationTypeId));
    return true;
  } catch {
    router.navigate(['/unauthorized']);
    return false;
  }
};
